import api from "./api";

class ProtheusAPI {
  async getCondPagamentoEDataEntrega(headers, params) {
    return await api.get("/get_cond_pagamento_e_data_entrega", { headers, params });
  }

  async incluirPedidoCompraProtheus(headers, params) {
    return await api({
      method: 'post',
      url: '/incluir_pedido_compra_protheus',
      headers,
      data: params
    });
  }
}

export default new ProtheusAPI();
